const selectors = {
  clientSecret: (state) => state.payment.clientSecret,
  transactionsList: (state) => state.payment.transactionsList,
};

export { selectors };
